/* SHADOWCORP THEME JS
   Drawer open/close, AJAX cart update, qty stepper, add-to-cart with cart drawer.
*/

(function () {
  'use strict';

  // ---------- Sound toggle (persistent preference + intro audio gate) ----------
  const SOUND_KEY = 'shadowcorp_sound_on';
  const soundToggle = document.getElementById('soundToggle');
  function isSoundOn() {
    try { return localStorage.getItem(SOUND_KEY) === '1'; } catch (e) { return false; }
  }
  function setSoundOn(on) {
    try { localStorage.setItem(SOUND_KEY, on ? '1' : '0'); } catch (e) {}
    if (soundToggle) {
      soundToggle.classList.toggle('is-on', on);
      soundToggle.setAttribute('aria-pressed', on ? 'true' : 'false');
    }
  }
  if (soundToggle) {
    setSoundOn(isSoundOn());
    soundToggle.addEventListener('click', function () {
      const next = !isSoundOn();
      setSoundOn(next);
      // If turning ON, play a brief audio test so user knows it works
      if (next) {
        const audio = document.getElementById('introAudio');
        if (audio) {
          try { audio.currentTime = 0; const p = audio.play(); if (p && p.catch) p.catch(() => {}); } catch (e) {}
        }
      } else {
        const audio = document.getElementById('introAudio');
        if (audio) { try { audio.pause(); } catch (e) {} }
      }
    });
  }

  // ---------- Intro splash: tap-to-enter then logo zoom + audio (once per session) ----------
  (function intro() {
    const splash = document.getElementById('introSplash');
    if (!splash) return;
    // Show only once per browser session
    try {
      if (sessionStorage.getItem('shadowcorp_intro_played') === '1') return;
    } catch (e) {}

    splash.classList.add('is-active');
    splash.setAttribute('aria-hidden', 'false');
    document.body.classList.add('intro-active');

    function startIntro() {
      if (splash.classList.contains('is-playing')) return;
      splash.classList.add('is-playing');
      try { sessionStorage.setItem('shadowcorp_intro_played', '1'); } catch (e) {}

      // User has interacted (tap counts), so audio will play unless toggle is off
      const audio = document.getElementById('introAudio');
      if (audio && (typeof isSoundOn !== 'function' || isSoundOn() !== false)) {
        try { audio.currentTime = 0; const p = audio.play(); if (p && p.catch) p.catch(() => {}); } catch (e) {}
        // Also flip sound toggle ON since user has interacted (unless they explicitly turned it off)
        try {
          if (localStorage.getItem('shadowcorp_sound_on') === null && typeof setSoundOn === 'function') {
            setSoundOn(true);
          }
        } catch (e) {}
      }

      // After zoom animation + fade, dismiss splash
      setTimeout(() => {
        splash.classList.add('is-fading');
        setTimeout(() => {
          splash.classList.remove('is-active', 'is-fading', 'is-playing');
          splash.setAttribute('aria-hidden', 'true');
          document.body.classList.remove('intro-active');
        }, 220);
      }, 900);
    }

    // Auto-start the intro immediately on load — animation always plays, audio attempts to play
    // (browsers may block audio autoplay on first visit; the animation still runs).
    startIntro();
  })();

  // ---------- Signup popup (shows on first visit, and again on a real refresh -- max once per minute) ----------
  (function signupPopup() {
    const popup = document.getElementById('signupPopup');
    if (!popup) return;

    // sessionStorage (not localStorage): clears when the tab/browser closes, so a fresh
    // visit later (even the same day) shows the popup again. Tracks a timestamp rather
    // than a plain seen/unseen flag so a genuine page refresh can re-trigger it, capped
    // to once per 60s so rapid refreshing doesn't spam the popup.
    const LAST_SHOWN_KEY = 'shadowcorp_signup_popup_last_shown';
    const COOLDOWN_MS = 60000;

    function showPopup() {
      popup.classList.add('is-active');
      popup.setAttribute('aria-hidden', 'false');
      document.body.classList.add('signup-popup-open');
      const focusable = popup.querySelector('input:not([disabled]), button');
      if (focusable) focusable.focus();
      try { sessionStorage.setItem(LAST_SHOWN_KEY, String(Date.now())); } catch (e) {}
    }

    function hidePopup() {
      popup.classList.remove('is-active');
      popup.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('signup-popup-open');
    }

    popup.addEventListener('click', function (e) {
      if (e.target.closest('[data-signup-popup-close]')) {
        hidePopup();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && popup.classList.contains('is-active')) {
        hidePopup();
      }
    });

    // Submission succeeds via AJAX now (no page reload), so the shared signup handler
    // dispatches this event directly instead of relying on a post-reload success check.
    popup.addEventListener('shadowcorp:signup-success', function () {
      popup.classList.add('is-success');
      setTimeout(hidePopup, 4000);
    });

    let lastShown = 0;
    try { lastShown = parseInt(sessionStorage.getItem(LAST_SHOWN_KEY), 10) || 0; } catch (e) {}

    const navEntry = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
    const isReload = navEntry ? navEntry.type === 'reload' : (performance.navigation && performance.navigation.type === 1);

    const neverShownThisSession = lastShown === 0;
    const cooldownExpired = (Date.now() - lastShown) >= COOLDOWN_MS;

    const shouldShow = neverShownThisSession || (isReload && cooldownExpired);
    if (!shouldShow) return;

    // Wait for the logo intro to finish its zoom + fade before showing, so they don't fight for attention
    const splash = document.getElementById('introSplash');
    let delay = 500;
    if (splash) {
      let introAlreadyPlayed = false;
      try { introAlreadyPlayed = sessionStorage.getItem('shadowcorp_intro_played') === '1'; } catch (e) {}
      delay = introAlreadyPlayed ? 500 : 1300;
    }
    setTimeout(showPopup, delay);
  })();

  // ---------- Drawer controller ----------
  const drawers = {
    cart: document.querySelector('[data-cart-drawer]'),
    menu: document.querySelector('[data-menu-drawer]')
  };

  function openDrawer(drawer) {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-open');
    const focusable = drawer.querySelector('button, a, input');
    if (focusable) focusable.focus();
  }

  function closeDrawer(drawer) {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('drawer-open');
  }

  function closeAllDrawers() {
    Object.values(drawers).forEach(closeDrawer);
  }

  document.addEventListener('click', function (e) {
    const cartToggle = e.target.closest('[data-cart-toggle]');
    if (cartToggle) {
      e.preventDefault();
      openDrawer(drawers.cart);
      return;
    }
    const menuToggle = e.target.closest('[data-menu-toggle]');
    if (menuToggle) {
      e.preventDefault();
      openDrawer(drawers.menu);
      return;
    }
    if (e.target.closest('[data-drawer-close]')) {
      closeAllDrawers();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAllDrawers();
  });

  // ---------- Qty stepper ----------
  document.addEventListener('click', function (e) {
    const dec = e.target.closest('[data-qty-decrease]');
    const inc = e.target.closest('[data-qty-increase]');
    if (!dec && !inc) return;
    const stepper = (dec || inc).closest('.qty-stepper');
    const input = stepper && stepper.querySelector('[data-qty-input]');
    if (!input) return;
    let val = parseInt(input.value, 10) || 0;
    val = dec ? Math.max(0, val - 1) : val + 1;
    input.value = val;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // ---------- AJAX Cart helpers ----------
  async function fetchCart() {
    const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    return res.json();
  }

  async function changeCartLine(line, quantity) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: parseInt(line, 10), quantity: parseInt(quantity, 10) })
    });
    return res.json();
  }

  async function addToCart(formData) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData
    });
    return res.json();
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.textContent = count;
      el.setAttribute('data-cart-count', count);
    });
  }

  async function refreshCartDrawer() {
    try {
      const res = await fetch('/?sections=cart-drawer-fragment', {
        headers: { Accept: 'application/json' }
      });
      // Fallback: simple reload of drawer markup via re-fetch of current page
      if (!res.ok) {
        window.location.reload();
        return;
      }
      // If the section endpoint isn't wired, just refresh state from /cart.js
      const cart = await fetchCart();
      updateCartCount(cart.item_count);
    } catch (err) {
      console.warn('Cart drawer refresh fallback', err);
      const cart = await fetchCart();
      updateCartCount(cart.item_count);
    }
  }

  // ---------- Cart line quantity update + remove ----------
  document.addEventListener('change', async function (e) {
    const input = e.target.closest('[data-qty-input]');
    if (!input) return;
    const line = input.getAttribute('data-line');
    if (!line) return;
    const qty = parseInt(input.value, 10);
    try {
      const cart = await changeCartLine(line, qty);
      updateCartCount(cart.item_count);
      // Reload page for cart page; cart drawer just updates count visually
      const onCartPage = document.body.classList.contains('template-cart');
      if (onCartPage || cart.item_count === 0) {
        window.location.reload();
      } else {
        // Update drawer subtotal if available
        const subtotalEl = document.querySelector('[data-cart-subtotal]');
        if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
      }
    } catch (err) {
      console.error('Cart update failed', err);
    }
  });

  document.addEventListener('click', async function (e) {
    const removeBtn = e.target.closest('[data-cart-remove]');
    if (!removeBtn) return;
    e.preventDefault();
    const line = removeBtn.getAttribute('data-line');
    try {
      const cart = await changeCartLine(line, 0);
      updateCartCount(cart.item_count);
      window.location.reload();
    } catch (err) {
      console.error('Remove failed', err);
    }
  });

  // ---------- Add to cart from product page ----------
  document.addEventListener('submit', async function (e) {
    const form = e.target.closest('.js-product-form');
    if (!form) return;
    e.preventDefault();
    const submitBtn = form.querySelector('[data-add-to-cart]');
    const originalText = submitBtn ? submitBtn.textContent : '';
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.textContent = 'Adding...';
    }
    try {
      const formData = new FormData(form);
      const item = await addToCart(formData);
      if (item.status && item.status >= 400) {
        if (submitBtn) submitBtn.textContent = item.description || 'Sold out';
        setTimeout(() => {
          if (submitBtn) {
            submitBtn.textContent = originalText;
            submitBtn.disabled = false;
          }
        }, 2000);
        return;
      }
      const cart = await fetchCart();
      updateCartCount(cart.item_count);
      if (submitBtn) {
        submitBtn.textContent = 'Added';
        setTimeout(() => {
          submitBtn.textContent = originalText;
          submitBtn.disabled = false;
        }, 1200);
      }
      openDrawer(drawers.cart);
      // Refresh drawer body so the new line appears
      window.location.reload();
    } catch (err) {
      console.error('Add to cart failed', err);
      if (submitBtn) {
        submitBtn.textContent = originalText;
        submitBtn.disabled = false;
      }
    }
  });

  // ---------- Variant select on product page ----------
  document.addEventListener('change', function (e) {
    if (!e.target.matches('[name^="options["]')) return;
    const form = e.target.closest('.js-product-form');
    if (!form) return;
    const select = form.querySelector('[data-variant-select]');
    if (!select) return;
    // Gather chosen option values
    const chosen = Array.from(form.querySelectorAll('[name^="options["]'))
      .filter(i => i.type === 'radio' ? i.checked : true)
      .map(i => i.value);
    // Find matching option in select by matching all chosen values in option text
    const opts = Array.from(select.options);
    const match = opts.find(opt => chosen.every(v => opt.text.includes(v)));
    if (match) {
      select.value = match.value;
      // Update submit button availability
      const submitBtn = form.querySelector('[data-add-to-cart]');
      if (submitBtn) {
        if (match.disabled) {
          submitBtn.disabled = true;
          submitBtn.textContent = 'Sold out';
        } else {
          submitBtn.disabled = false;
          submitBtn.textContent = 'Add to cart';
        }
      }
    }
  });

  // ---------- Initial cart count sync ----------
  fetchCart().then(cart => updateCartCount(cart.item_count)).catch(() => {});

  // ---------- Password landing: discreet password reveal toggle ----------
  document.addEventListener('click', function (e) {
    const trigger = e.target.closest('[data-password-toggle]');
    if (!trigger) return;
    const target = document.getElementById('passwordEntry');
    if (!target) return;
    target.hidden = !target.hidden;
    if (!target.hidden) {
      const input = target.querySelector('input[type="password"]');
      if (input) input.focus();
    }
  });

  // ---------- Password page draggable spin logo ----------
  const spinLogo = document.querySelector('[data-spin-logo]');
  if (spinLogo) {
    let rotation = 0;
    let velocity = 0;
    let dragging = false;
    let lastX = 0;
    let lastTime = 0;
    let momentumFrame = null;
    const SENSITIVITY = 0.8;
    const FRICTION = 0.94;

    const apply = () => {
      spinLogo.style.transform = 'rotate(' + rotation.toFixed(2) + 'deg)';
    };

    const stopMomentum = () => {
      if (momentumFrame) {
        cancelAnimationFrame(momentumFrame);
        momentumFrame = null;
      }
    };

    const settleToHome = () => {
      // Predict where free momentum would naturally come to rest
      let predicted = rotation;
      let v = velocity * 16;
      while (Math.abs(v) > 0.01) {
        predicted += v;
        v *= FRICTION;
      }
      // Snap that resting point to the nearest horizontal (multiple of 360°)
      const target = Math.round(predicted / 360) * 360;
      const animate = () => {
        const diff = target - rotation;
        if (Math.abs(diff) < 0.2) {
          rotation = target;
          apply();
          momentumFrame = null;
          return;
        }
        rotation += diff * 0.12;
        apply();
        momentumFrame = requestAnimationFrame(animate);
      };
      momentumFrame = requestAnimationFrame(animate);
    };

    spinLogo.addEventListener('pointerdown', (e) => {
      dragging = true;
      velocity = 0;
      lastX = e.clientX;
      lastTime = performance.now();
      stopMomentum();
      try { spinLogo.setPointerCapture(e.pointerId); } catch (err) {}
      e.preventDefault();
    });

    spinLogo.addEventListener('pointermove', (e) => {
      if (!dragging) return;
      const now = performance.now();
      const dx = e.clientX - lastX;
      const dt = Math.max(now - lastTime, 1);
      rotation += dx * SENSITIVITY;
      velocity = (dx * SENSITIVITY) / dt;
      lastX = e.clientX;
      lastTime = now;
      apply();
    });

    const endDrag = (e) => {
      if (!dragging) return;
      dragging = false;
      try { spinLogo.releasePointerCapture(e.pointerId); } catch (err) {}
      settleToHome();
    };
    spinLogo.addEventListener('pointerup', endDrag);
    spinLogo.addEventListener('pointercancel', endDrag);
    spinLogo.addEventListener('dragstart', (e) => e.preventDefault());
  }

  // ---------- Password page static status (Drop 7 date TBD, no countdown) ----------
  const landingClock = document.querySelector('[data-landing-clock]');
  if (landingClock) {
    landingClock.textContent = 'CRASH BOOT COMING SOON';
  }

  // ---------- Popup static status (Drop 7 date TBD, no countdown) ----------
  const popupClock = document.querySelector('[data-popup-clock]');
  if (popupClock) {
    popupClock.textContent = '';
  }

  // ---------- Sign-up form (email OR phone; SMS requires its own opt-in checkbox, email does not) ----------
  // Submits to a Cloudflare Worker relay (customerSet via Admin API) instead of Shopify's native
  // form 'customer' POST -- the store runs Shopify's New Customer Accounts system, under which the
  // classic Liquid form does not reliably create customer records (confirmed via live testing 2026.08.12).
  const SIGNUP_RELAY_URL = 'https://shadowcorp-signup-relay.shadowcorp-la.workers.dev';

  const signupForm = document.querySelector('.js-signup-form');
  if (signupForm) {
    const phoneEl = signupForm.querySelector('[name="contact[phone]"]');
    const emailEl = signupForm.querySelector('[name="contact[email]"]');
    const smsConsentWrap = signupForm.querySelector('.js-signup-sms-consent-wrap');
    const fieldsEl = signupForm.querySelector('.js-signup-fields');
    const successEl = signupForm.querySelector('.js-signup-success');
    const introEl = document.querySelector('.js-signup-intro');

    // SMS consent checkbox only applies once a phone number is entered, so keep it hidden (and unrequired) until then
    function toggleSmsConsent() {
      if (!smsConsentWrap) return;
      const hasPhone = phoneEl && phoneEl.value.trim().length > 0;
      smsConsentWrap.hidden = !hasPhone;
      if (!hasPhone) {
        const consentEl = signupForm.querySelector('.js-signup-sms-consent');
        if (consentEl) consentEl.checked = false;
      }
    }
    if (phoneEl) {
      phoneEl.addEventListener('input', toggleSmsConsent);
      toggleSmsConsent();
    }

    signupForm.addEventListener('submit', function (e) {
      e.preventDefault();

      const countryEl = signupForm.querySelector('.js-signup-country');
      const smsConsentEl = signupForm.querySelector('.js-signup-sms-consent');
      const tagsEl = signupForm.querySelector('.js-signup-tags');
      const errorEl = signupForm.querySelector('.js-signup-error');
      const smsConsentErrorEl = signupForm.querySelector('.js-signup-sms-consent-error');
      const serverErrorEl = signupForm.querySelector('.js-signup-server-error');
      const submitBtn = signupForm.querySelector('button[type="submit"]');

      const email = emailEl ? emailEl.value.trim() : '';
      const rawPhone = phoneEl ? phoneEl.value.trim() : '';
      const dialCode = countryEl ? countryEl.value : '';
      const smsConsent = smsConsentEl ? smsConsentEl.checked : false;

      // Build full international phone number if user entered digits
      let phone = '';
      if (rawPhone) {
        const digitsOnly = rawPhone.replace(/[^\d+]/g, '');
        if (digitsOnly.startsWith('+')) {
          phone = digitsOnly;
        } else {
          phone = dialCode + digitsOnly.replace(/^0+/, '');
        }
      }

      // Either field is enough on its own
      if (!email && !phone) {
        if (errorEl) errorEl.hidden = false;
        if (smsConsentErrorEl) smsConsentErrorEl.hidden = true;
        if (serverErrorEl) serverErrorEl.hidden = true;
        return;
      }
      if (errorEl) errorEl.hidden = true;

      // SMS is TCPA-regulated and requires its own explicit, unchecked-by-default opt-in.
      // Email is CAN-SPAM (opt-out based), so submitting the form is sufficient consent -- no checkbox needed.
      if (phone && smsConsentEl && !smsConsent) {
        if (smsConsentErrorEl) smsConsentErrorEl.hidden = false;
        if (serverErrorEl) serverErrorEl.hidden = true;
        return;
      }
      if (smsConsentErrorEl) smsConsentErrorEl.hidden = true;
      if (serverErrorEl) serverErrorEl.hidden = true;

      const baseTags = tagsEl ? (tagsEl.getAttribute('data-base-tags') || tagsEl.value) : '';
      const tags = baseTags ? [baseTags] : [];
      if (phone && smsConsent) tags.push('sms-signup');
      if (email) tags.push('email-signup');

      if (submitBtn) submitBtn.disabled = true;

      fetch(SIGNUP_RELAY_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: email || undefined,
          phone: phone || undefined,
          smsConsent: !!(phone && smsConsent),
          tags: tags,
        }),
      })
        .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
        .then(function (result) {
          if (result.ok && result.data && result.data.success) {
            if (fieldsEl) fieldsEl.hidden = true;
            if (successEl) successEl.hidden = false;
            if (introEl) introEl.hidden = true;
            signupForm.dispatchEvent(new CustomEvent('shadowcorp:signup-success', { bubbles: true }));
          } else {
            if (submitBtn) submitBtn.disabled = false;
            if (serverErrorEl) {
              serverErrorEl.textContent = (result.data && result.data.error) || 'Something went wrong. Please try again.';
              serverErrorEl.hidden = false;
            }
          }
        })
        .catch(function () {
          if (submitBtn) submitBtn.disabled = false;
          if (serverErrorEl) {
            serverErrorEl.textContent = 'Something went wrong. Please try again.';
            serverErrorEl.hidden = false;
          }
        });
    });
  }

  // ---------- Modal (size guide, etc.) ----------
  function openModal(name) {
    const m = document.querySelector('[data-modal="' + name + '"]');
    if (!m) return;
    m.setAttribute('aria-hidden', 'false');
    document.body.classList.add('modal-open');
    const focusable = m.querySelector('button, a, input, [tabindex]');
    if (focusable) focusable.focus();
  }
  function closeAllModals() {
    document.querySelectorAll('.modal').forEach(m => m.setAttribute('aria-hidden', 'true'));
    document.body.classList.remove('modal-open');
  }
  document.addEventListener('click', function (e) {
    const opener = e.target.closest('[data-modal-open]');
    if (opener) {
      e.preventDefault();
      openModal(opener.getAttribute('data-modal-open'));
      return;
    }
    if (e.target.closest('[data-modal-close]')) {
      closeAllModals();
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAllModals();
  });

  // ---------- Lookbook horizontal drag-to-scroll + wheel-to-horizontal (desktop) ----------
  document.querySelectorAll('[data-lookbook-row]').forEach(function (row) {
    let isDown = false;
    let startX = 0;
    let scrollStart = 0;
    let hasDragged = false;
    row.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return; // let native touch scroll handle phones
      isDown = true;
      hasDragged = false;
      startX = e.clientX;
      scrollStart = row.scrollLeft;
    });
    row.addEventListener('pointermove', function (e) {
      if (!isDown || e.pointerType === 'touch') return;
      const dx = e.clientX - startX;
      if (Math.abs(dx) > 5 && !hasDragged) {
        hasDragged = true;
        row.classList.add('lookbook-row--grabbing');
      }
      if (hasDragged) {
        row.scrollLeft = scrollStart - dx;
        e.preventDefault();
      }
    });
    const release = function () {
      isDown = false;
      row.classList.remove('lookbook-row--grabbing');
      if (hasDragged) setTimeout(function () { hasDragged = false; }, 50);
    };
    row.addEventListener('pointerup', release);
    row.addEventListener('pointerleave', release);
    row.addEventListener('pointercancel', release);
    // Suppress tile click only if a real drag happened
    row.addEventListener('click', function (e) {
      if (hasDragged) { e.preventDefault(); e.stopPropagation(); }
    }, true);
    // Two-finger trackpad / mouse wheel scrolls the page vertically as normal.
    // Horizontal movement through the row only happens via drag or the edge-hover
    // auto-scroll below, never via wheel/trackpad.
  });

  // ---------- Lookbook edge-hover auto-scroll (desktop) ----------
  // Park the cursor at the left/right edge of the screen to scroll the
  // filmstrip row under it, instead of dragging or using the trackpad.
  if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    const EDGE_ZONE = 140; // px from the viewport edge that triggers scrolling
    const MAX_SPEED = 36; // px per frame at the very edge
    let hoverRow = null;
    let hoverDir = 0; // -1 left, 1 right, 0 idle
    let hoverSpeed = 0;
    let hoverRafId = null;

    function rowUnderY(clientY) {
      const rows = document.querySelectorAll('[data-lookbook-row]');
      for (let i = 0; i < rows.length; i++) {
        const rect = rows[i].getBoundingClientRect();
        if (clientY >= rect.top && clientY <= rect.bottom) return rows[i];
      }
      return null;
    }

    function stepAutoScroll() {
      if (hoverRow && hoverDir !== 0) {
        hoverRow.scrollLeft += hoverDir * hoverSpeed;
        hoverRafId = requestAnimationFrame(stepAutoScroll);
      } else {
        hoverRafId = null;
      }
    }

    document.addEventListener('mousemove', function (e) {
      // Don't fight the fullscreen lightbox when it's open.
      if (document.body.classList.contains('lookbox-open')) {
        hoverDir = 0;
        hoverRow = null;
        return;
      }
      const row = rowUnderY(e.clientY);
      if (!row) {
        hoverDir = 0;
        hoverRow = null;
        return;
      }
      const vw = window.innerWidth;
      if (e.clientX < EDGE_ZONE) {
        hoverRow = row;
        hoverDir = -1;
        hoverSpeed = MAX_SPEED * (1 - e.clientX / EDGE_ZONE);
      } else if (e.clientX > vw - EDGE_ZONE) {
        hoverRow = row;
        hoverDir = 1;
        hoverSpeed = MAX_SPEED * (1 - (vw - e.clientX) / EDGE_ZONE);
      } else {
        hoverDir = 0;
        hoverRow = null;
      }
      if (hoverDir !== 0 && !hoverRafId) {
        hoverRafId = requestAnimationFrame(stepAutoScroll);
      }
    });

    document.addEventListener('mouseleave', function () {
      hoverDir = 0;
      hoverRow = null;
    });
  }

  // ---------- Lookbox (filmstrip lightbox) ----------
  const lookbox = document.querySelector('[data-lookbox]');
  const strip = document.querySelector('[data-lookbox-strip]');
  const counter = document.querySelector('[data-lookbox-counter]');

  function openLookbox(collectionIdx, imageIdx) {
    if (!lookbox || !strip) return;
    // Build filmstrip from all tiles in the chosen collection
    const tiles = document.querySelectorAll('[data-lookbook-tile][data-collection="' + collectionIdx + '"]');
    if (!tiles.length) return;
    strip.innerHTML = '';
    tiles.forEach((tile, i) => {
      const frame = document.createElement('div');
      frame.className = 'lookbox__frame';
      frame.dataset.frameIndex = i;
      const img = document.createElement('img');
      img.src = tile.dataset.fullSrc;
      img.alt = tile.dataset.caption || '';
      img.loading = i === imageIdx ? 'eager' : 'lazy';
      frame.appendChild(img);
      strip.appendChild(frame);
    });
    lookbox.setAttribute('aria-hidden', 'false');
    document.body.classList.add('lookbox-open');
    // Scroll to the clicked image after the strip is rendered
    requestAnimationFrame(() => {
      const target = strip.querySelector('[data-frame-index="' + imageIdx + '"]');
      if (target) {
        strip.scrollTo({ left: target.offsetLeft, behavior: 'instant' in strip.style ? 'instant' : 'auto' });
      }
      updateLookboxCounter();
    });
  }

  function closeLookbox() {
    if (!lookbox) return;
    lookbox.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('lookbox-open');
    if (strip) strip.innerHTML = '';
    if (counter) counter.textContent = '';
  }

  function updateLookboxCounter() {
    if (!strip || !counter) return;
    const frames = strip.querySelectorAll('.lookbox__frame');
    if (!frames.length) { counter.textContent = ''; return; }
    const scrollCenter = strip.scrollLeft + strip.clientWidth / 2;
    let activeIndex = 0;
    let smallestDistance = Infinity;
    frames.forEach((f, i) => {
      const center = f.offsetLeft + f.offsetWidth / 2;
      const d = Math.abs(center - scrollCenter);
      if (d < smallestDistance) { smallestDistance = d; activeIndex = i; }
    });
    counter.textContent = (activeIndex + 1) + ' / ' + frames.length;
  }

  // Click on a tile opens lookbox
  document.addEventListener('click', function (e) {
    const tile = e.target.closest('[data-lookbook-tile]');
    if (tile) {
      e.preventDefault();
      openLookbox(tile.dataset.collection, parseInt(tile.dataset.imageIndex, 10));
      return;
    }
    const close = e.target.closest('[data-lookbox-close]');
    if (close) {
      e.preventDefault();
      closeLookbox();
    }
  });

  // Lookbox (lightbox) — desktop drag-to-scroll + wheel-to-horizontal
  if (strip) {
    let isDown = false;
    let startX = 0;
    let scrollStart = 0;
    let hasDragged = false;
    strip.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return;
      isDown = true;
      hasDragged = false;
      startX = e.clientX;
      scrollStart = strip.scrollLeft;
      strip.style.cursor = 'grab';
    });
    strip.addEventListener('pointermove', function (e) {
      if (!isDown || e.pointerType === 'touch') return;
      const dx = e.clientX - startX;
      if (Math.abs(dx) > 5 && !hasDragged) {
        hasDragged = true;
        strip.style.cursor = 'grabbing';
        strip.style.userSelect = 'none';
        strip.style.scrollBehavior = 'auto';
      }
      if (hasDragged) {
        strip.scrollLeft = scrollStart - dx;
        e.preventDefault();
      }
    });
    const releaseStrip = function () {
      isDown = false;
      strip.style.cursor = '';
      strip.style.userSelect = '';
      strip.style.scrollBehavior = '';
      if (hasDragged) {
        updateLookboxCounter();
        setTimeout(function () { hasDragged = false; }, 50);
      }
    };
    strip.addEventListener('pointerup', releaseStrip);
    strip.addEventListener('pointerleave', releaseStrip);
    strip.addEventListener('pointercancel', releaseStrip);
    strip.addEventListener('dragstart', function (e) { e.preventDefault(); });
    // Convert vertical mouse wheel into horizontal scroll inside the lightbox
    strip.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
        e.preventDefault();
        strip.scrollLeft += e.deltaY;
      }
    }, { passive: false });
    // Update counter live as the user scrolls/drags
    strip.addEventListener('scroll', function () { updateLookboxCounter(); });
  }

  // Keyboard: Escape closes, Arrow keys advance frames
  document.addEventListener('keydown', function (e) {
    if (!lookbox || lookbox.getAttribute('aria-hidden') !== 'false') return;
    if (e.key === 'Escape') { closeLookbox(); return; }
    if (!strip) return;
    if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
      const frames = strip.querySelectorAll('.lookbox__frame');
      if (!frames.length) return;
      const scrollCenter = strip.scrollLeft + strip.clientWidth / 2;
      let activeIndex = 0;
      let smallestDistance = Infinity;
      frames.forEach((f, i) => {
        const center = f.offsetLeft + f.offsetWidth / 2;
        const d = Math.abs(center - scrollCenter);
        if (d < smallestDistance) { smallestDistance = d; activeIndex = i; }
      });
      const next = e.key === 'ArrowRight' ? Math.min(activeIndex + 1, frames.length - 1) : Math.max(activeIndex - 1, 0);
      strip.scrollTo({ left: frames[next].offsetLeft, behavior: 'smooth' });
      e.preventDefault();
    }
  });

  // Update counter while scrolling
  if (strip) {
    let scrollRaf = null;
    strip.addEventListener('scroll', function () {
      if (scrollRaf) cancelAnimationFrame(scrollRaf);
      scrollRaf = requestAnimationFrame(updateLookboxCounter);
    }, { passive: true });
  }

  // ---------- Product page media swipe indicator (mobile) ----------
  const productMedia = document.querySelector('.product-page__media');
  const productDots = document.querySelector('[data-media-dots]');
  if (productMedia && productDots) {
    const items = productMedia.querySelectorAll('.product-page__media-item');
    const dots = productDots.querySelectorAll('.product-page__dot');

    function updateProductDots() {
      const scrollCenter = productMedia.scrollLeft + productMedia.clientWidth / 2;
      let activeIdx = 0;
      let minDist = Infinity;
      items.forEach(function (item, idx) {
        const center = item.offsetLeft + item.offsetWidth / 2;
        const d = Math.abs(center - scrollCenter);
        if (d < minDist) { minDist = d; activeIdx = idx; }
      });
      dots.forEach(function (dot, idx) {
        dot.classList.toggle('is-active', idx === activeIdx);
      });
    }

    let productRaf = null;
    productMedia.addEventListener('scroll', function () {
      if (productRaf) cancelAnimationFrame(productRaf);
      productRaf = requestAnimationFrame(updateProductDots);
    }, { passive: true });

    // Initial sync in case the page loads scrolled
    updateProductDots();
  }


})();
